export const ACCESSES = [
  'Super Admin',
  'Data Administrator',
  'Reporting',
  'Admin'
]

export const ROLES = [
  { name: 'Owner', value: 'owner' },
  { name: 'Admin', value: 'admin' },
  { name: 'Viewer', value: 'viewer' },
  { name: 'Guest', value: 'guest' }
]

export const ROLES_ROUTES = {
  owner: ['Partner Portal', 'Discovery Profile', 'Risk Profile', 'Utilities', 'Data Inventory', 'Account Settings', 'Billing', 'Profiles', 'Scheduled Profiles'],
  admin: ['Partner Portal', 'Discovery Profile', 'Risk Profile', 'Utilities', 'Data Inventory', 'Account Settings', 'Profiles', 'Scheduled Profiles'],
  viewer: ['Partner Portal', 'Discovery Profile', 'Risk Profile', 'Data Inventory', 'Account Settings', 'Profiles'],
  guest: ['Discovery Profile', 'Risk Profile']
}

export const BANDS = [
  '0 - 250K',
  '250K - 500K',
  '500K - 1M',
  '1M - 5M',
  '5M - 10M',
  '10M - 25M',
  '25M - 50M',
  '50M - 100M',
  '100M - 200M',
  '200M - 500M',
  '500M - 1B',
  'More than 1B'
]

export const AUTH0_DOMAIN = process.env.VUE_APP_AUTH0_DOMAIN
export const AUTH0_CLIENT_ID = process.env.VUE_APP_AUTH0_CLIENT_ID
